import { Menu } from "@mui/material";
import styled from "styled-components";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import type { AppGlueAny } from "../../rule-engine-core/Common/AppGlueAny";

export const ValueEditorWrapper = styled.div<{ content: AppGlueAny }>`
    position: relative;
    min-width: 120px;
    min-height: 44px;
    display: flex;
    align-items: center;
    flex-direction: column;

    align-items: start;
    justify-content: center;

    &:after {
        display: block;
        content: "${(props) => props.content}";
        height: 0;
        visibility: hidden;
        padding: 0 12px;
        opacity: 0;
    }

    .MuiInputBase-input,
    .MuiInputBase-input,
    .MuiOutlinedInput-input {
        font-family: Inter !important;
        font-size: 12px !important;
        font-style: normal;
        font-weight: 400 !important;
        line-height: 17px !important;
        letter-spacing: 0px;
        text-align: left;
        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
    }

    .MuiOutlinedInput-input,
    .TextList-TextBox,
    .NumberList-TextBox {
        padding: 6px 12px;
        background: ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
    }

    .TextList-TextBox .MuiOutlinedInput-input,
    .NumberList-TextBox .MuiOutlinedInput-input {
        background: transparent;
    }

    .MuiOutlinedInput-input {
        height: 20px;
    }

    .MuiOutlinedInput-notchedOutline {
        border: none;
        border-bottom: solid 1px ${UIStyleConstants.BLUE_LIGHTER_COLOR};
        border-radius: 0;
    }

    .MuiFormControl-root {
        display: flex;
    }

    .MuiSwitch-root {
        height: 25px !important;
        width: 40px !important;
        padding: 0;
        border-radius: 20px;
    }

    .MuiSwitch-switchBase {
        padding: 2px !important;

        &.Mui-checked {
            transform: translateX(15px) !important;
        }
    }

    input[type="date"],
    input[type="datetime-local"] {
        position: relative;

        &::-webkit-calendar-picker-indicator {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 20px;
            width: 20px;
            opacity: 0;
        }

        &:hover::-webkit-calendar-picker-indicator {
            opacity: 1;
        }
    }

    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */

    input[type="number"] {
        -moz-appearance: textfield;
    }
`;

export const EditLayerWrapper = styled(Menu)`
    && {
        .MuiMenu-paper {
            background: ${UIStyleConstants.WHITE_COLOR};
            border: 1px solid ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
            border-radius: 5px;

            min-width: 200px;
            z-index: 10;

            .MuiMenu-list {
                display: flex;
                flex-direction: column;

                > div {
                    padding: 5px;
                }

                .MuiInputBase-input,
                .MuiInputBase-input,
                .MuiOutlinedInput-input {
                    font-family: Inter !important;
                    font-size: 12px !important;
                    font-style: normal;
                    font-weight: 400 !important;
                    line-height: 17px !important;
                    letter-spacing: 0px;
                    text-align: left;
                    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
                }

                .MuiOutlinedInput-input {
                    padding: 6px 12px;
                    background: ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
                    height: 20px;
                }

                .TextList-TextBox .MuiOutlinedInput-input,
                .NumberList-TextBox .MuiOutlinedInput-input {
                    background: transparent;
                }

                .MuiOutlinedInput-notchedOutline {
                    border: none;
                    border-bottom: solid 1px ${UIStyleConstants.GRAY_LIGHTER_COLOR};
                    border-radius: 0;
                }

                .MuiFormControl-root {
                    display: flex;
                }

                .MuiSwitch-root {
                    height: 25px !important;
                    width: 40px !important;
                    padding: 0;
                    border-radius: 20px;
                }

                .MuiSwitch-switchBase {
                    padding: 2px !important;

                    &.Mui-checked {
                        transform: translateX(15px) !important;
                    }
                }

                input[type="date"],
                input[type="datetime-local"] {
                    position: relative;

                    &::-webkit-calendar-picker-indicator {
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        height: 20px;
                        width: 20px;
                        opacity: 0;
                    }

                    &:hover::-webkit-calendar-picker-indicator {
                        opacity: 1;
                    }
                }

                input[type="number"]::-webkit-outer-spin-button,
                input[type="number"]::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }

                /* Firefox */

                input[type="number"] {
                    -moz-appearance: textfield;
                }
            }
        }
    }
`;

export const FieldNameRender = styled.div`
    font-size: 12px;
    font-weight: 500;
    color: ${UIStyleConstants.BLUE_COLOR};
    display: flex;
    align-items: center;
    min-height: 32px;
`;

export const DisplayEditModeRender = styled.div`
    position: relative;
    min-width: 120px;
    min-height: 44px;
    display: flex;
    align-items: center;
`;

export const EditModeValueEditorRender = styled.div<{ content: AppGlueAny }>`
    border-radius: 2px;
    width: 100%;
    min-height: 100%;
    display: flex;
    align-items: center;

    max-width: ${(props) => (`${props.content}`.length > 0 ? `${`${props.content}`.length * 6.25}px` : "none")};
    min-width: 100%;
`;

export const Row = styled.div`
    position: relative;

    .ValueEditor-delete-line {
        opacity: 0;
        transition: opacity 0.1s ease-in;
    }

    &:hover .ValueEditor-delete-line {
        opacity: 1;
    }
`;

export const DeleteButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${UIStyleConstants.WHITE_COLOR};

    box-shadow: 0px 6px 8px -2px ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
    cursor: pointer;
`;
